import React from 'react';
import { t } from 'Src/i18n';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';

export const TransportIncentive = () => {
  return (
    <div className="m-20 text-12 text-black">
      <div className="mb-15 flex gap-15 text-16 font-bold">
        <Icon className="shrink-0 text-sienna" name={ICONS.ALL_INCLUSIVE} />
        {t('faceting.transport.departureCities.reinsurance')}
      </div>
      <div className="mb-10">{t('faceting.transport.departureCities.guarantee')}</div>
      <div>{t('faceting.transport.departureCities.schedule')}</div>
    </div>
  );
};
